export function resolveProfilePic(url, fallback = 'static/images/student.png') {
  if (!url) return fallback;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const base = process.env.REACT_APP_AUTH_URL || '';
  return `${base}${url.startsWith('/') ? url : `/${url}`}`;
}

export function userDisplayName(user) {
  if (!user) return 'User';
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
  return name || user.email || 'User';
}
